export default __webpack_public_path__ + "static/char-v-35-ja-0a665b1425b8dd88207c8e808fa377b8.mp4";